export default "__VITE_ASSET__DNmUUdDI__"